import { AKeywordContainer, AKeywordRow, AKeywordText } from '../Keyword';

interface IKey {
  key: string;
  description: string;
}
interface IKeywordsDescription {
  title: string;
  keys: IKey[];
}
export const KeywordsDescription: React.FC<IKeywordsDescription> = ({
  title,
  keys,
}) => {
  return (
    <AKeywordContainer>
      <AKeywordRow>
        <AKeywordText bold>{title}</AKeywordText>
      </AKeywordRow>
      {keys.map((key, index) => (
        <AKeywordRow key={`keyword-${index}`}>
          <AKeywordText bold>{key.key}</AKeywordText>:
          <AKeywordText key={`keyword-${index}`}>
            {key.description}
          </AKeywordText>
        </AKeywordRow>
      ))}
      <AKeywordRow>
        <AKeywordText bold danger style={{ marginTop: 10, fontSize: 12 }}>
          IMPORTANTE: As palavras chaves deverão ficar da seguinte forma:{' '}
          {`{palavra}`} - com as chaves em volta e sem espaço entre as chaves.
        </AKeywordText>
        <AKeywordText bold danger style={{ marginTop: 10, fontSize: 12 }}>
          Observação: As palavras-chave serão substituídas pelos dados que serão
          inseridos no documento do cliente
        </AKeywordText>
      </AKeywordRow>
    </AKeywordContainer>
  );
};
